export default [{
  path: '/company/view',
  name: 'viewcompany',
  component: () => import('@/app/company/CompanyView'),
  meta: {
    resource: 'companies',
    actions: ['read']
  }
}]
